/**
 *   Generated file. Do not edit
 */
import './converter-stream-extension';

import { BodyConverter } from '@iotize/tap/client/api';

import { LoginCredential } from './models';
import { LoginCredentialHashed } from './models';
import { HostProtocol } from '@iotize/tap';
import { SecurityOptions } from './models';
import { NfcPairingMode } from './models';
import { WirelessPairingOptions } from './models';
import { LowPowerOptimizationLevel } from './models';
import { CpuFrequencyOptions } from './models';
import { CpuFrequencySpeed } from '@iotize/tap';
import { PowerOptimizationOptions } from './models';
import { ServiceCode } from './models';
import { NetworkOptions } from './models';
import { NfcConnectionPriority } from './models';
import { ProtocolMaxFrameSize } from './models';
import { MultiRequestFrame } from './models';
import { MultiResponseFrame } from './models';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';
import { TapRequestFrame } from '@iotize/tap/client/api';

export class LoginCredentialConverter
  implements BodyConverter<LoginCredential>
{
  public encode(
    model: LoginCredential,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeLoginCredential(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): LoginCredential {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readLoginCredential();
  }
}

export class LoginCredentialHashedConverter
  implements BodyConverter<LoginCredentialHashed>
{
  public encode(
    model: LoginCredentialHashed,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeLoginCredentialHashed(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): LoginCredentialHashed {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readLoginCredentialHashed();
  }
}

export class SecurityOptionsConverter
  implements BodyConverter<SecurityOptions>
{
  public encode(
    model: SecurityOptions,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeSecurityOptions(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): SecurityOptions {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readSecurityOptions();
  }
}

export class WirelessPairingOptionsConverter
  implements BodyConverter<WirelessPairingOptions>
{
  public encode(
    model: WirelessPairingOptions,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeWirelessPairingOptions(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): WirelessPairingOptions {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readWirelessPairingOptions();
  }
}

export class CpuFrequencyOptionsConverter
  implements BodyConverter<CpuFrequencyOptions>
{
  public encode(
    model: CpuFrequencyOptions,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeCpuFrequencyOptions(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): CpuFrequencyOptions {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readCpuFrequencyOptions();
  }
}

export class PowerOptimizationOptionsConverter
  implements BodyConverter<PowerOptimizationOptions>
{
  public encode(
    model: PowerOptimizationOptions,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writePowerOptimizationOptions(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): PowerOptimizationOptions {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readPowerOptimizationOptions();
  }
}

export class NetworkOptionsConverter implements BodyConverter<NetworkOptions> {
  public encode(
    model: NetworkOptions,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeNetworkOptions(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): NetworkOptions {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readNetworkOptions();
  }
}

export class ProtocolMaxFrameSizeConverter
  implements BodyConverter<ProtocolMaxFrameSize>
{
  public encode(
    model: ProtocolMaxFrameSize,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeProtocolMaxFrameSize(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): ProtocolMaxFrameSize {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readProtocolMaxFrameSize();
  }
}

export class MultiRequestFrameConverter
  implements BodyConverter<MultiRequestFrame>
{
  public encode(
    model: MultiRequestFrame,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeMultiRequestFrame(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): MultiRequestFrame {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readMultiRequestFrame();
  }
}

export class MultiResponseFrameConverter
  implements BodyConverter<MultiResponseFrame>
{
  public encode(
    model: MultiResponseFrame,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeMultiResponseFrame(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): MultiResponseFrame {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readMultiResponseFrame();
  }
}
